import React from "react";
import styled from "styled-components";
import { Link } from "../Link";

interface Props {
  href: string;
}
const StyledLink = styled(props => (
  <Link
    {...props}
    color="white"
    display="inline-block"
    height="100%"
    verticalAlign="middle"
    textAlign="center"
    lineHeight="1.42857143"
    fontSize="12px"
    py={["14px", "14px", "14px", "14px", "16px"]}
    px={["10px", "10px", "10px", "10px", "18px"]}
  />
))`
  &:hover {
    color: white;
  }
`;

export const NavItemLink: React.FC<Props> = ({ children, ...props }) => {
  return (
    <StyledLink data-testid="NavItemLink" {...props}>
      {children}
    </StyledLink>
  );
};

NavItemLink.defaultProps = {
  href: "/",
};
